import { Icon, Stack, StackProps, Typography } from '@mui/material';
import { DoneIcon } from '@schooly/style';
import { useIntl } from 'react-intl';

type FilterDropdownSingleSelectRowProps<T> = {
  arrangeBy: T;
  isSelected?: boolean;
  getOptionLabelId: (o: T) => string;
} & StackProps;
export const FilterDropdownSingleSelectRow = <T extends string>({
  arrangeBy,
  isSelected,
  getOptionLabelId,
  ...stackProps
}: FilterDropdownSingleSelectRowProps<T>) => {
  const { $t } = useIntl();

  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      px={1}
      gap={2}
      py={0.5}
      sx={(theme) => ({
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme.palette.background.default,
        },
      })}
      {...stackProps}
    >
      <Typography variant="h3" color={!isSelected ? 'common.grey2' : undefined}>
        {$t({
          id: getOptionLabelId(arrangeBy),
        })}
      </Typography>
      <Icon
        sx={{
          visibility: isSelected ? 'visible' : 'hidden',
        }}
      >
        <DoneIcon />
      </Icon>
    </Stack>
  );
};
